/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import { create } from 'zustand';

export type ManageAgenciesScenario =
  | 'api'
  | 'five'
  | 'five_mixed'
  | 'empty'
  | 'payment_pending'
  | 'one_active'
  | 'one_pending'
  | 'two_active'
  | 'two_mixed'
  | 'two_pending';

interface ManageAgenciesMockState {
  scenario: ManageAgenciesScenario;
  setScenario: (s: ManageAgenciesScenario) => void;
}

/**
 * Zustand store for switching agency list scenarios in the Dev Cockpit.
 * Only active when DEBUG=true. In production this store is never imported.
 */
const STORAGE_KEY = 'dev:agencies-scenario';

export const useManageAgenciesMockStore = create<ManageAgenciesMockState>((set) => ({
  scenario: (sessionStorage.getItem(STORAGE_KEY) as ManageAgenciesScenario) || 'api',
  setScenario: (scenario) => {
    sessionStorage.setItem(STORAGE_KEY, scenario);
    set({ scenario });
  },
}));
